import { render, staticRenderFns } from "./CheckStatus.vue?vue&type=template&id=28bd340c&scoped=true&"
import script from "./CheckStatus.vue?vue&type=script&lang=js&"
export * from "./CheckStatus.vue?vue&type=script&lang=js&"
import style0 from "./CheckStatus.vue?vue&type=style&index=0&id=28bd340c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd340c",
  null
  
)

export default component.exports